import { useEffect, useState } from 'react';

/** True while the CSS media query matches (false where matchMedia does not exist). */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : false,
  );
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const list = window.matchMedia(query);
    const onChange = (): void => setMatches(list.matches);
    onChange();
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);
  return matches;
}

/** Touch-only devices (a phone or a tablet without a mouse): the arena is desktop only. */
export const TOUCH_ONLY = '(pointer: coarse) and (hover: none)';
/** Below this the hangar stacks its panels and the tables scroll (BUILD_PLAN: mobile hangar). */
export const NARROW = '(max-width: 800px)';
